
function ResearchPage() {
	return ( 
	<div className="research_content">
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/atypgeod-final-w.pdf")} target='_blank' rel="noreferrer">
					Special geodesics and atypical intersections
				</a>
				, 7 pp, &nbsp;
				<a href='https://link.springer.com/article/10.1007/s40316-026-00276-z' target='_blank' rel="noreferrer">
					<i>Annales mathématiques du Québec (online)</i>
				</a>
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/realgtrs-final-w.pdf")} target='_blank' rel="noreferrer">
					Real geometric transcendence for uniformization maps of algebraic Riemann surfaces
				</a>
				, with&nbsp;
				<a href='https://sites.google.com/view/arshaysheth/home' target='_blank' rel="noreferrer">A. Sheth</a> 
				, 23 pp, <i>preprint</i>
			</div>
		</div>

		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/wildrs-final-w.pdf")} target='_blank' rel="noreferrer">
					Moduli spaces of untwisted wild Riemann surfaces
				</a>
				, with&nbsp;
				<a href='https://www.normalesup.org/~doucot/' target='_blank' rel="noreferrer">J. Douçot</a> 
				&nbsp;and&nbsp;
				<a href='https://sites.google.com/view/gabrielerembado/home' target='_blank' rel="noreferrer">G. Rembado</a>
				, 24 pp, <i>preprint</i>
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/sha-visp-final-w.pdf")} target='_blank' rel="noreferrer">
				Congruences of modular forms and modularity of Tate-Shafarevich classes
				</a>
				, 18 pp, in <i><a href='https://link.springer.com/book/9783032131225' target='_blank' rel="noreferrer">Elliptic Curves and Modular Forms in Arithmetic Geometry</a>, Springer (2026)</i>; 
				&nbsp;<i><a href={require("../content/Palermo 07-2024-w.pdf")} target='_blank' rel="noreferrer">slides</a></i>
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/purelocalWMCGs-final-w.pdf")} target='_blank' rel="noreferrer">
					Local wild mapping class groups and cabled braids
				</a>
				, with&nbsp;
				<a href='https://www.normalesup.org/~doucot/' target='_blank' rel="noreferrer">J. Douçot</a> 
				&nbsp;and&nbsp;
				<a href='https://sites.google.com/view/gabrielerembado/home' target='_blank' rel="noreferrer">G. Rembado</a>
				, 34 pp,&nbsp; 
				<a href='https://aif.centre-mersenne.org/articles/10.5802/aif.3778/' target='_blank' rel="noreferrer">
					<i>Annales de l'Institut Fourier (online)</i>
				</a>
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/Hilbert_cohomFl_final_w.pdf")} target='_blank' rel="noreferrer">
					On the étale cohomology of Hilbert modular varieties with torsion coefficients
				</a>
				, with&nbsp;
				<a href='https://www.ma.imperial.ac.uk/~acaraian/' target='_blank' rel="noreferrer">A. Caraiani</a> 
				, 41 pp, &nbsp;
				<a href='https://www.cambridge.org/core/journals/compositio-mathematica/article/on-the-etale-cohomology-of-hilbert-modular-varieties-with-torsion-coefficients/3A607A05C6DB54AF82DC67FBE2CDB95B' target='_blank' rel="noreferrer"><i>Compositio Mathematica</i></a>
				&nbsp;159 (2023)
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/K-Hilb-ext-final-w.pdf")} target='_blank' rel="noreferrer">
					The tame Hilbert symbol via K-theory and central extensions
				</a>
				, 15 pp,&nbsp;
				<a href='https://www.sciencedirect.com/science/article/pii/S0022314X22001263' target='_blank' rel="noreferrer"><i>Journal of Number Theory</i></a>
				&nbsp;242 (2023)
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/real_bialg_final_w.pdf")} target='_blank' rel="noreferrer">
					Special curves in modular surfaces
				</a>
				, 13 pp,&nbsp;
				<a href='https://www.cambridge.org/core/journals/canadian-mathematical-bulletin/article/abs/special-curves-in-modular-surfaces/E327F297E517F193F470C7D305DA41A6' target='_blank' rel="noreferrer"><i>Canadian Mathematical Bulletin</i></a>
				&nbsp;66 (2023); some&nbsp;
				<a href='https://sites.google.com/view/luca-dallava/#h.rbrk2krip31b' target='_blank' rel="noreferrer">pictures</a>
			</div>
		</div>
		<div className="research_item">
			<i className="bullet pi pi-bookmark"></i>
			<div>
				<a href={require("../content/bk_final_w.pdf")} target='_blank' rel="noreferrer">
					On the Bloch-Kato conjecture for Hilbert modular forms
				</a>
				, 28 pp,&nbsp;
				<a href='https://link.springer.com/article/10.1007/s00209-020-02689-0' target='_blank' rel="noreferrer"><i>Mathematische Zeitschrift</i></a>
				&nbsp;299 (2021); from part of my&nbsp;
				<a href='https://d-nb.info/1191690938/34' target='_blank' rel="noreferrer">thesis</a>
				;&nbsp;
				<a href='https://www.youtube.com/watch?v=iyxLelRcf5w&t=2382s' target='_blank' rel="noreferrer">video</a>
			</div>
		</div>
	</div>);
}

export default ResearchPage;